<template>
  <v-container>
    <v-card outlined>
      <v-card-title>
        <v-layout>
          <v-flex xs4>
            <!-- <div class="subtitle-2 mb-1">Select Region</div> -->
            <v-select
              outlined
              dense
              hide-details
              return-object
              :items="regionsWithAll"
              v-model="selectedRegion"
              item-text="name"
              placeholder="Select Region"
              @change="selectRegion"
            >
            </v-select>
          </v-flex>

          <v-flex text-right>
            <v-btn @click="openNewSubscriberDialog" depressed color="primary">
              Create New Subscriber
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-layout class="mx-4">
        <v-flex xs4>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-data-table
        :headers="headers"
        :items="subscribers"
        :items-per-page="30"
        class="elevation-0"
        :search="search"
      >
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
        </template>
        <template v-slot:item.createdAt="{ item }">
          <div>
            {{ iMoment(item.createdAt) }}
          </div>
        </template>
      </v-data-table>
    </v-card>
    <new-subscriber-dialog :collection="collection" ref="newSubscriberDialog" />
    <edit-subscriber-dialog
      :collection="collection"
      :details="editedItem"
      ref="editSubscriberDialog"
    />
    <v-dialog v-model="dialogDelete" width="300">
      <v-card>
        <v-card-title>Are you sure you want to delete this item?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            color="error"
            class="text-none subtitle-2"
            @click="dialogDelete = false"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            class="text-none subtitle-2"
            text
            @click="deleteItemConfirm"
            >Delete</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import NewSubscriberDialog from "../components/NewSubscriberDialog";
import EditSubscriberDialog from "../components/EditSubscriberDialog";
import { mapActions, mapState } from "vuex";
import moment from "moment";
export default {
  components: { NewSubscriberDialog, EditSubscriberDialog },
  data() {
    return {
      search: "",
      collection: "subscribers",
      dialogDelete: false,
      selectedRegion: {},
      itemToDelete: {
        name: "",
        latitude: "",
        longitude: "",
      },
      headers: [
        {
          text: "Subscriber",
          align: "start",
          sortable: true,
          value: "entity.title",
        },
        {
          text: "Region",
          value: "entity.region.name",
        },
        // { text: "Font Family", value: "fontFamily" },
        // { text: "Font Name", value: "fontName" },
        // { text: "Background Color", value: "backgroundColor" },
        // { text: "Font Color", value: "fontColor" },
        { text: "Created At", value: "createdAt" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      editedItem: {
        name: "",
        latitude: "",
        longitude: "",
      },
      editedIndex: -1,
      defaultItem: {
        name: "",
        latitude: "",
        longitude: "",
      },
      //   pins: [
      //     {
      //       name: "Events",
      //       fontFamily: "MeterialDesignIcons",
      //       fontName: "",
      //       backgroundColor: "",
      //       fontColor: "",
      //     },
      //   ],
    };
  },
  computed: {
    ...mapState("$_entity", ["subscribers"]),
    ...mapState("$_home", ["regions"]),
    regionsWithAll() {
      var arr = [];

      arr.push({ name: "All" });
      arr = arr.concat(this.regions);
      return arr;
    },
  },
  created() {
    if (this.subscribers.length === 0) {
      this.getSubscribers({
        type: "subscriber",
        collection: this.collection,
        mutation: "updateSubscribers",
      });
    }
    if (this.regions.length === 0) {
      this.getRegions({ collection: "regions", mutation: "updateRegions" });
    }
  },
  methods: {
    ...mapActions({
      getSubscribers: "$_entity/getSubscribers",
      getSubscribersByRegion: "$_entity/getSubscribersByRegion",
      deleteSubscriber: "$_entity/deleteSubscriber",
      getRegions: "$_home/getContent",
    }),
    selectRegion() {
      // console.log("selectedRegion: ", this.selectedRegion);
      if (this.selectedRegion.name == "All") {
        this.getSubscribers({
          type: "subscriber",
          collection: this.collection,
          mutation: "updateSubscribers",
        });
      } else {
        this.getSubscribersByRegion({
          type: "subscriber",
          collection: this.collection,
          mutation: "updateSubscribers",
          region: this.selectedRegion,
        });
      }
    },
    iMoment(timestamp) {
      if (timestamp) {
        let temp = timestamp.seconds * 1000;
        return moment(temp).format("lll");
      } else {
        return 0;
      }
    },
    openNewSubscriberDialog() {
      this.$refs.newSubscriberDialog.toggleDialog();
    },
    editItem(item) {
      this.editedIndex = this.subscribers.indexOf(item);
      this.editedItem = Object.assign({}, this.subscribers[this.editedIndex]);

      console.log("Edited Item: ", this.editedItem);

      this.$refs.editSubscriberDialog.toggleDialog(this.editedItem);
    },
    deleteItem(item) {
      this.editedIndex = this.subscribers.indexOf(item);
      this.itemToDelete = Object.assign({}, this.subscribers[this.editedIndex]);
      this.dialogDelete = true;

      console.log(item);
    },
    deleteItemConfirm() {
      this.deleteSubscriber({
        details: this.itemToDelete,
        type: "subscriber",
        collection: this.collection,
      }).then(() => {
        this.dialogDelete = false;
        this.getSubscribers({
          type: "subscriber",
          collection: this.collection,
          mutation: "updateSubscribers",
        });
      });
    },
  },
};
</script>

<style>
</style>